import { render, staticRenderFns } from "./EditNode.vue?vue&type=template&id=4bb2b58a&"
import script from "./EditNode.vue?vue&type=script&lang=js&"
export * from "./EditNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports